import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  fr: {
    // Navbar
    nav: {
      home: "Accueil",
      services: "Services",
      offers: "Offres",
      about: "À propos",
      contact: "Contact",
      allServices: "Tous nos services",
      visibility: "Visibilité",
      brandImage: "Image de Marque",
      growth: "Croissance",
      allOffers: "Toutes nos offres",
      packVisibility: "Pack Visibilité 360",
      packImage: "Pack Image Premium",
      packGrowth: "Pack Croissance +",
      servicesCart: "Services à la carte",
      support360: "Accompagnement 360° Sur Mesure",
      letsTalk: "Parlons-en",
      ourExpertise: "Nos expertises",
      ourFormulas: "Nos formules"
    },
    // Hero
    hero: {
      subtitle: "Agence Premium de Branding & Stratégie",
      title1: "Nous construisons des",
      titleHighlight: "marques fortes",
      title2: "visibles et désirables",
      description: "Transformez votre entreprise en marque premium avec un accompagnement stratégique et créatif de haut niveau",
      cta1: "Démarrer votre projet",
      cta2: "Découvrir nos services"
    },
    // Stats
    stats: {
      years: "Années d'expertise",
      projects: "Projets réalisés",
      growth: "Croissance moyenne",
      satisfaction: "Clients satisfaits"
    },
    // Services
    services: {
      title: "Nos Pôles d'Expertise",
      subtitle: "Une approche 360° pour transformer votre marque",
      visibility: {
        title: "Visibilité",
        tagline: "Augmentez votre présence digitale",
        description: "Sites web, SEO, réseaux sociaux, applications"
      },
      brandImage: {
        title: "Image de Marque",
        tagline: "Créez une identité unique",
        description: "Branding, identité visuelle, supports commerciaux"
      },
      growth: {
        title: "Croissance",
        tagline: "Générez des leads qualifiés",
        description: "Acquisition, tunnels de vente, automation"
      },
      discoverServices: "Découvrir nos services"
    },
    // Contact
    contact: {
      title: "Prêt à transformer votre marque ?",
      subtitle: "Discutons de votre projet",
      form: {
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        phone: "Téléphone",
        company: "Entreprise",
        message: "Votre message",
        send: "Envoyer le message",
        sending: "Envoi en cours...",
        success: "Message envoyé avec succès !",
        successDetail: "Nous vous répondrons dans les plus brefs délais."
      },
      info: {
        email: "Email",
        phone: "Téléphone",
        offices: "Nos bureaux"
      }
    },
    // Footer
    footer: {
      description: "Agence premium de branding et stratégie digitale. Nous accompagnons les entreprises ambitieuses dans leur transformation.",
      quickLinks: "Liens rapides",
      contactUs: "Contactez-nous",
      rights: "Tous droits réservés."
    },
    // About
    about: {
      heroTitle: "À propos d'ImpaKt Studio",
      heroSubtitle: "Un groupe international au service de votre ambition",
      whyChoose: "Pourquoi choisir ImpaKt Studio ?",
      visionTitle: "Notre Vision",
      missionTitle: "Notre Mission",
      philosophyTitle: "Notre Philosophie",
      multiSector: "Expertise Multi-Sectorielle",
      allSectors: "Tous les secteurs, toutes les ambitions"
    },
    // Offers
    offers: {
      heroTitle: "Des solutions adaptées à chaque ambition",
      heroSubtitle: "Packs stratégiques, services à la carte ou accompagnement sur mesure",
      strategicPacks: "Les Packs Stratégiques",
      servicesTitle: "Services à la Carte",
      servicesSubtitle: "Vous avez un besoin spécifique ?",
      faqTitle: "Questions fréquentes",
      fromPrice: "À partir de",
      popular: "Populaire",
      customQuote: "Demander un devis personnalisé"
    },
    // Common
    common: {
      learnMore: "En savoir plus",
      backTo: "Retour",
      seeAll: "Voir tout",
      backToOffers: "Retour aux offres",
      backToServices: "Retour aux services",
      startingFrom: "À partir de",
      requestQuote: "Demander un devis",
      seeAllOffers: "Voir toutes nos offres",
      contactUs: "Contactez-nous",
      ourServices: "Nos services"
    },
    // Home Page
    home: {
      expertiseTitle: "Nos Expertises",
      expertiseSubtitle: "3 Pôles Stratégiques pour Votre Croissance",
      expertiseDesc: "Une approche structurée pour maximiser votre impact",
      whyUsTitle: "Pourquoi ImpaKt Studio ?",
      whyUsSubtitle: "Une expertise internationale au service de votre ambition",
      whyUsDesc: "Avec 15+ ans d'expérience et une présence sur 3 continents, nous combinons expertise locale et vision globale pour créer des marques qui se démarquent.",
      discoverHistory: "Découvrir notre histoire",
      officesWorld: "Bureaux dans le monde",
      ctaTitle: "Prêt à transformer votre marque ?",
      ctaSubtitle: "Réservez un appel stratégique gratuit avec notre équipe",
      ctaButton1: "Parlons de votre projet",
      ctaButton2: "Voir nos offres",
      strategicApproach: "Approche stratégique",
      strategicApproachDesc: "Positionnement différenciant basé sur vos forces",
      creativeExcellence: "Excellence créative",
      creativeExcellenceDesc: "Design premium qui reflète votre valeur",
      measurableResults: "Résultats mesurables",
      measurableResultsDesc: "ROI concret et croissance durable",
      viewAllServices: "Voir tous nos services"
    },
    // Services Page
    servicesPage: {
      heroTitle: "Comment pouvons-nous vous aider ?",
      heroSubtitle: "Une approche structurée en 3 pôles stratégiques pour maximiser votre impact",
      polesTitle: "3 Pôles Stratégiques",
      polesSubtitle: "Chaque pôle répond à un besoin spécifique de votre développement. Découvrez nos expertises.",
      allServicesTitle: "Tous nos services en un coup d'œil",
      servicesCount: "services répartis sur nos 3 pôles d'expertise",
      seeDetails: "Voir les détails",
      discover: "Découvrir",
      ctaTitle: "Vous ne savez pas par où commencer ?",
      ctaSubtitle: "Nos experts analysent votre situation et vous recommandent les services adaptés à vos objectifs",
      ctaButton: "Réserver un appel stratégique gratuit",
      ourApproach: "Notre approche",
      servicesIncluded: "Services inclus dans le pôle",
      fullRange: "Une gamme complète de services pour répondre à tous vos besoins en",
      specializedServices: "Services spécialisés",
      toMaximize: "Pour maximiser votre",
      andReachGoals: "et atteindre vos objectifs",
      boostYour: "Prêt à booster votre",
      discussProject: "Discutons de votre projet et définissons ensemble la meilleure stratégie"
    },
    // Contact Page
    contactPage: {
      heroTitle: "Parlons de votre projet",
      heroSubtitle: "Réservez un appel stratégique gratuit avec notre équipe d'experts",
      formTitle: "Prêt à transformer votre marque ?",
      formSubtitle: "Prenez rendez-vous pour un appel stratégique gratuit et découvrons ensemble comment faire de votre entreprise une marque premium",
      contactDirectly: "Contactez-nous directement",
      contactDirectlyDesc: "Notre équipe est à votre disposition pour répondre à toutes vos questions et vous accompagner dans votre projet.",
      address: "Adresse",
      messageSent: "Message envoyé !",
      messageSuccess: "Merci pour votre message. Notre équipe vous contactera dans les plus brefs délais.",
      sendAnother: "Envoyer un autre message",
      submitDisclaimer: "En soumettant ce formulaire, vous acceptez d'être contacté par ImpaKt Studio concernant votre demande.",
      errorMessage: "Une erreur est survenue. Veuillez réessayer.",
      testimonialsTitle: "Témoignages",
      testimonialsSubtitle: "Ce que disent nos clients",
      testimonialsDesc: "Découvrez comment nous avons aidé nos clients à transformer leur marque"
    },
    // About Page
    aboutPage: {
      heroSubtitle: "À Propos",
      heroDesc: "Agence internationale de branding & stratégie - 15+ ans d'expertise, 8 bureaux sur 3 continents",
      whoWeAre: "Qui sommes-nous",
      whyChoose: "Pourquoi choisir ImpaKt Studio ?",
      aboutDesc1: "est un groupe international spécialisé en stratégie de marque, branding et marketing digital. Bien plus qu'une simple agence, nous sommes un partenaire stratégique engagé dans la réussite de nos clients.",
      aboutDesc2: "Avec une présence sur",
      continents: "3 continents",
      and: "et",
      offices: "8 bureaux",
      aboutDesc3: "à travers le monde, notre groupe combine l'agilité d'une structure à taille humaine avec la puissance d'un réseau international.",
      aboutDesc4: "Fort de",
      yearsExperience: "15+ ans d'expérience",
      aboutDesc5: "dans des environnements exigeants — projets internationaux complexes, transformation digitale, CRM/Data, stratégies de croissance — nous mettons notre savoir-faire pluridisciplinaire au service d'entreprises de toutes tailles et de tous secteurs.",
      ambitionQuote: "Notre ambition : faire de chaque marque une référence incontournable sur son marché.",
      excellence: "Excellence",
      excellenceDesc: "Un engagement constant vers la qualité et la performance",
      proximity: "Proximité",
      proximityDesc: "Une relation de confiance et un accompagnement sur-mesure",
      results: "Résultats",
      resultsDesc: "Orientation ROI et croissance mesurable pour chaque projet",
      innovation: "Innovation",
      innovationDesc: "Approches modernes et solutions à la pointe de la technologie",
      whatDrivesUs: "Ce qui nous anime",
      visionMissionTitle: "Vision, Mission & Philosophie",
      missionTitle: "Notre Mission",
      missionDesc: "Transformer chaque entreprise en marque d'exception, capable de se démarquer, d'inspirer confiance et de générer une croissance durable sur tous les marchés.",
      visionTitle: "Notre Vision",
      visionDesc: "Devenir le partenaire stratégique de référence pour les entreprises ambitieuses qui veulent conquérir leurs marchés et laisser une empreinte mémorable dans leur industrie.",
      philosophyTitle: "Notre Philosophie",
      philosophyDesc: "Nous croyons que chaque marque a une histoire unique à raconter. Notre rôle est de révéler cette essence, de l'amplifier et de la transformer en avantage compétitif décisif.",
      multiSectorTitle: "Expertise Multi-Sectorielle",
      allSectorsTitle: "Tous les secteurs, toutes les ambitions",
      allSectorsDesc: "Notre expertise transversale nous permet d'accompagner des entreprises de toutes industries. Quelle que soit votre activité, nous comprenons vos enjeux et adaptons nos stratégies à votre marché.",
      andMore: "+ Et bien d'autres...",
      industryQuote: "Chaque industrie a ses codes. Notre force est de les maîtriser pour mieux les transcender.",
      internationalPresence: "Présence Internationale",
      officesTitle: "8 Bureaux sur 3 Continents",
      officesDesc: "Une présence locale combinée à une expertise internationale",
      headquarters: "Siège",
      ourClients: "Nos Clients",
      whoWeWorkWith: "Pour qui travaillons-nous ?",
      clientsDesc: "De la startup au grand groupe, nous accompagnons toutes les entreprises ambitieuses",
      workTogether: "Travaillons ensemble",
      workTogetherDesc: "Découvrez comment nous pouvons vous aider à atteindre vos objectifs",
      yearsLabel: "Ans d'expertise",
      projectsLabel: "Projets livrés"
    },
    // Offers Page
    offersPage: {
      groupedOffers: "Offres Groupées",
      strategicPacksTitle: "Les Packs Stratégiques",
      strategicPacksDesc: "Des solutions clé en main pour répondre à vos objectifs de visibilité, d'image ou de croissance",
      flexibility: "Flexibilité",
      alaCarteTitle: "Services à la Carte",
      alaCarteDesc: "Vous avez un besoin spécifique ? Chaque service peut être adapté à votre budget et vos objectifs.",
      startingPrice: "À partir de 250 € par service",
      premiumOffer: "Offre Premium",
      support360Title: "Accompagnement 360° Sur Mesure",
      support360Desc: "Pour les entreprises à forte ambition, nous prenons en main votre communication dans son intégralité. De la stratégie de marque à l'exécution des campagnes, nous devenons votre partenaire privilégié.",
      support360Desc2: "Une stratégie de marque globale et déployée sur tous les canaux, avec des indicateurs de performance dédiés pour mesurer et optimiser vos résultats.",
      whatWeHandle: "Ce que nous prenons en charge",
      idealFor: "Idéal pour :",
      idealForDesc: "Grands comptes, entreprises en forte croissance, organisations multi-sites",
      faqTitle: "Questions fréquentes",
      faqSubtitle: "Vous avez des questions sur nos offres ? Nous avons les réponses",
      noAnswer: "Vous ne trouvez pas la réponse à votre question ?",
      teamHelp: "Notre équipe est là pour vous aider. Contactez-nous directement.",
      ctaTitle: "Prêt à transformer votre marque ?",
      ctaSubtitle: "Discutons de vos objectifs et trouvons ensemble la solution idéale",
      ctaButton1: "Demander un devis gratuit",
      ctaButton2: "Découvrir nos services",
      meetUs: "Prenons rendez-vous",
      popular: "Populaire"
    },
    // Pack pages
    packs: {
      strategicPack: "Pack Stratégique",
      whatsIncluded: "Ce qui est inclus",
      theResult: "Le résultat",
      importantNote: "Note importante",
      // Visibility Pack
      visibilityName: "Pack Visibilité 360",
      visibilityTagline: "Vous voulez exister en ligne et attirer vos premiers clients ?",
      visibilityDesc: "Ce pack clé en main vous offre une présence digitale complète et cohérente pour être visible là où vos clients vous cherchent.",
      visibilityCta: "Je veux être visible",
      visibilityResultTitle: "Une vitrine digitale qui travaille pour vous, 24h/24",
      visibilityResultDesc: "Avec le Pack Visibilité 360, vous bénéficiez d'une présence en ligne professionnelle et cohérente qui attire naturellement vos clients potentiels.",
      visibilityFeature1Title: "Site internet professionnel",
      visibilityFeature1Desc: "Pages stratégiques : Accueil, Services, À propos, Contact. Design moderne et responsive.",
      visibilityFeature2Title: "Optimisation SEO de base",
      visibilityFeature2Desc: "Pour être trouvé sur Google par vos clients potentiels.",
      visibilityFeature3Title: "Création de 3 réseaux sociaux",
      visibilityFeature3Desc: "Instagram, Facebook, LinkedIn - optimisés et prêts à l'emploi.",
      visibilityFeature4Title: "1 mois de contenu planning",
      visibilityFeature4Desc: "Calendrier éditorial pour démarrer votre communication sereinement.",
      visibilityBenefit1: "Une vitrine digitale qui travaille pour vous, 24h/24",
      visibilityBenefit2: "Présence professionnelle sur les réseaux sociaux",
      visibilityBenefit3: "Meilleure visibilité sur les moteurs de recherche",
      visibilityBenefit4: "Crédibilité renforcée auprès de vos prospects",
      visibilityCtaTitle: "Prêt à devenir visible ?",
      continueVisibility: "Visibilité continue",
      // Image Premium Pack
      imageName: "Pack Image Premium",
      imageTagline: "Votre marque mérite une identité forte et mémorable.",
      imageDesc: "Construisez une marque qui reflète votre valeur et vous différencie de la concurrence avec une identité visuelle cohérente et impactante.",
      imageCta: "Je veux une identité unique",
      imageResultTitle: "Une marque qui inspire confiance et se différencie",
      imageResultDesc: "Avec le Pack Image Premium, vous obtenez une identité visuelle professionnelle et cohérente qui positionne votre entreprise comme une référence dans votre secteur.",
      imageFeature1Title: "Logo & Charte graphique complète",
      imageFeature1Desc: "Couleurs, typographies, univers visuel unique qui vous représente.",
      imageFeature2Title: "Supports commerciaux essentiels",
      imageFeature2Desc: "Flyers, brochure ou catalogue professionnels pour vos ventes.",
      imageFeature3Title: "Templates réseaux sociaux",
      imageFeature3Desc: "Visuels personnalisés et prêts à l'emploi pour vos publications.",
      imageFeature4Title: "Papeterie professionnelle",
      imageFeature4Desc: "Cartes de visite, signature email et en-tête personnalisés.",
      imageBenefit1: "Une marque qui inspire confiance et se différencie",
      imageBenefit2: "Identité visuelle cohérente sur tous les canaux",
      imageBenefit3: "Perception premium de votre entreprise",
      imageBenefit4: "Mémorabilité accrue auprès de vos prospects",
      imageCtaTitle: "Prêt à créer une marque mémorable ?",
      uniqueCustom: "Unique & sur-mesure",
      completeIdentity: "Une identité visuelle complète",
      // Growth Pack
      growthName: "Pack Croissance +",
      growthTagline: "Vous voulez générer des leads et accélérer vos ventes ?",
      growthDesc: "Ce pack met en place un système d'acquisition performant pour transformer vos visiteurs en clients, avec des processus automatisés et mesurables.",
      growthCta: "Je veux développer mon chiffre",
      growthResultTitle: "Une machine à générer des leads qualifiés",
      growthResultDesc: "Avec le Pack Croissance+, vous mettez en place un système d'acquisition qui travaille pour vous 24h/24, convertissant automatiquement vos visiteurs en prospects puis en clients.",
      growthFeature1Title: "Audit et recommandations stratégiques",
      growthFeature1Desc: "Analyse complète de votre positionnement et plan d'action personnalisé.",
      growthFeature2Title: "Tunnel de conversion complet",
      growthFeature2Desc: "De la découverte à l'achat : landing pages, séquences, optimisation CRO.",
      growthFeature3Title: "Campagne de test sur les réseaux sociaux",
      growthFeature3Desc: "Configuration et optimisation de vos premières campagnes ads (budget non inclus).",
      growthFeature4Title: "Automation email",
      growthFeature4Desc: "Séquences automatisées pour suivre et convertir vos prospects.",
      growthBenefit1: "Génération de leads qualifiés en continu",
      growthBenefit2: "Taux de conversion optimisé à chaque étape",
      growthBenefit3: "Processus d'acquisition automatisé",
      growthBenefit4: "ROI mesurable et optimisé en permanence",
      growthCtaTitle: "Prêt à accélérer votre croissance ?",
      growthNote: "Le budget publicitaire (Facebook Ads, Google Ads, LinkedIn Ads) n'est pas inclus dans ce pack. Nous configurons et optimisons vos campagnes, mais vous gérez directement votre budget auprès des plateformes. Nous vous recommandons un budget test minimum pour démarrer.",
      qualifiedLeads: "Leads qualifiés",
      continuously: "en continu",
      completeAcquisition: "Un système d'acquisition complet"
    }
  },
  en: {
    // Navbar
    nav: {
      home: "Home",
      services: "Services",
      offers: "Offers",
      about: "About",
      contact: "Contact",
      allServices: "All our services",
      visibility: "Visibility",
      brandImage: "Brand Image",
      growth: "Growth",
      allOffers: "All our offers",
      packVisibility: "Visibility 360 Pack",
      packImage: "Premium Image Pack",
      packGrowth: "Growth + Pack",
      servicesCart: "À la carte services",
      support360: "360° Custom Support",
      letsTalk: "Let's talk",
      ourExpertise: "Our expertise",
      ourFormulas: "Our formulas"
    },
    // Hero
    hero: {
      subtitle: "Premium Branding & Strategy Agency",
      title1: "We build",
      titleHighlight: "strong brands",
      title2: "visible and desirable",
      description: "Transform your business into a premium brand with high-level strategic and creative support",
      cta1: "Start your project",
      cta2: "Discover our services"
    },
    // Stats
    stats: {
      years: "Years of expertise",
      projects: "Projects completed",
      growth: "Average growth",
      satisfaction: "Satisfied clients"
    },
    // Services
    services: {
      title: "Our Areas of Expertise",
      subtitle: "A 360° approach to transform your brand",
      visibility: {
        title: "Visibility",
        tagline: "Increase your digital presence",
        description: "Websites, SEO, social media, applications"
      },
      brandImage: {
        title: "Brand Image",
        tagline: "Create a unique identity",
        description: "Branding, visual identity, commercial materials"
      },
      growth: {
        title: "Growth",
        tagline: "Generate qualified leads",
        description: "Acquisition, sales funnels, automation"
      },
      discoverServices: "Discover our services"
    },
    // Contact
    contact: {
      title: "Ready to transform your brand?",
      subtitle: "Let's discuss your project",
      form: {
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        phone: "Phone",
        company: "Company",
        message: "Your message",
        send: "Send message",
        sending: "Sending...",
        success: "Message sent successfully!",
        successDetail: "We will get back to you as soon as possible."
      },
      info: {
        email: "Email",
        phone: "Phone",
        offices: "Our offices"
      }
    },
    // Footer
    footer: {
      description: "Premium branding and digital strategy agency. We support ambitious companies in their transformation.",
      quickLinks: "Quick links",
      contactUs: "Contact us",
      rights: "All rights reserved."
    },
    // About
    about: {
      heroTitle: "About ImpaKt Studio",
      heroSubtitle: "An international group at the service of your ambition",
      whyChoose: "Why choose ImpaKt Studio?",
      visionTitle: "Our Vision",
      missionTitle: "Our Mission",
      philosophyTitle: "Our Philosophy",
      multiSector: "Multi-Sector Expertise",
      allSectors: "All sectors, all ambitions"
    },
    // Offers
    offers: {
      heroTitle: "Solutions adapted to every ambition",
      heroSubtitle: "Strategic packs, à la carte services or custom support",
      strategicPacks: "Strategic Packs",
      servicesTitle: "À la Carte Services",
      servicesSubtitle: "Do you have a specific need?",
      faqTitle: "Frequently asked questions",
      fromPrice: "Starting from",
      popular: "Popular",
      customQuote: "Request a custom quote"
    },
    // Common
    common: {
      learnMore: "Learn more",
      backTo: "Back to",
      seeAll: "See all",
      backToOffers: "Back to offers",
      backToServices: "Back to services",
      startingFrom: "Starting from",
      requestQuote: "Request a quote",
      seeAllOffers: "See all our offers",
      contactUs: "Contact us",
      ourServices: "Our services"
    },
    // Home Page
    home: {
      expertiseTitle: "Our Expertise",
      expertiseSubtitle: "3 Strategic Pillars for Your Growth",
      expertiseDesc: "A structured approach to maximize your impact",
      whyUsTitle: "Why ImpaKt Studio?",
      whyUsSubtitle: "International expertise at the service of your ambition",
      whyUsDesc: "With 15+ years of experience and a presence on 3 continents, we combine local expertise and global vision to create brands that stand out.",
      discoverHistory: "Discover our story",
      officesWorld: "Offices worldwide",
      ctaTitle: "Ready to transform your brand?",
      ctaSubtitle: "Book a free strategic call with our team",
      ctaButton1: "Let's discuss your project",
      ctaButton2: "See our offers",
      strategicApproach: "Strategic approach",
      strategicApproachDesc: "Differentiating positioning based on your strengths",
      creativeExcellence: "Creative excellence",
      creativeExcellenceDesc: "Premium design that reflects your value",
      measurableResults: "Measurable results",
      measurableResultsDesc: "Concrete ROI and sustainable growth",
      viewAllServices: "View all our services"
    },
    // Services Page
    servicesPage: {
      heroTitle: "How can we help you?",
      heroSubtitle: "A structured approach with 3 strategic pillars to maximize your impact",
      polesTitle: "3 Strategic Pillars",
      polesSubtitle: "Each pillar addresses a specific need in your development. Discover our expertise.",
      allServicesTitle: "All our services at a glance",
      servicesCount: "services across our 3 areas of expertise",
      seeDetails: "See details",
      discover: "Discover",
      ctaTitle: "Don't know where to start?",
      ctaSubtitle: "Our experts analyze your situation and recommend services adapted to your goals",
      ctaButton: "Book a free strategic call",
      ourApproach: "Our approach",
      servicesIncluded: "Services included in the",
      fullRange: "A complete range of services to meet all your needs in",
      specializedServices: "Specialized services",
      toMaximize: "To maximize your",
      andReachGoals: "and reach your goals",
      boostYour: "Ready to boost your",
      discussProject: "Let's discuss your project and define the best strategy together"
    },
    // Contact Page
    contactPage: {
      heroTitle: "Let's discuss your project",
      heroSubtitle: "Book a free strategic call with our team of experts",
      formTitle: "Ready to transform your brand?",
      formSubtitle: "Schedule a free strategic call and let's discover together how to turn your business into a premium brand",
      contactDirectly: "Contact us directly",
      contactDirectlyDesc: "Our team is at your disposal to answer all your questions and support you in your project.",
      address: "Address",
      messageSent: "Message sent!",
      messageSuccess: "Thank you for your message. Our team will contact you as soon as possible.",
      sendAnother: "Send another message",
      submitDisclaimer: "By submitting this form, you agree to be contacted by ImpaKt Studio regarding your request.",
      errorMessage: "An error occurred. Please try again.",
      testimonialsTitle: "Testimonials",
      testimonialsSubtitle: "What our clients say",
      testimonialsDesc: "Discover how we helped our clients transform their brand"
    },
    // About Page
    aboutPage: {
      heroSubtitle: "About",
      heroDesc: "International branding & strategy agency - 15+ years of expertise, 8 offices on 3 continents",
      whoWeAre: "Who we are",
      whyChoose: "Why choose ImpaKt Studio?",
      aboutDesc1: "is an international group specialized in brand strategy, branding and digital marketing. More than just an agency, we are a strategic partner committed to our clients' success.",
      aboutDesc2: "With a presence on",
      continents: "3 continents",
      and: "and",
      offices: "8 offices",
      aboutDesc3: "around the world, our group combines the agility of a human-sized structure with the power of an international network.",
      aboutDesc4: "With",
      yearsExperience: "15+ years of experience",
      aboutDesc5: "in demanding environments — complex international projects, digital transformation, CRM/Data, growth strategies — we put our multidisciplinary expertise at the service of companies of all sizes and sectors.",
      ambitionQuote: "Our ambition: to make every brand an unmissable reference in its market.",
      excellence: "Excellence",
      excellenceDesc: "A constant commitment to quality and performance",
      proximity: "Proximity",
      proximityDesc: "A relationship of trust and tailor-made support",
      results: "Results",
      resultsDesc: "ROI orientation and measurable growth for each project",
      innovation: "Innovation",
      innovationDesc: "Modern approaches and cutting-edge solutions",
      whatDrivesUs: "What drives us",
      visionMissionTitle: "Vision, Mission & Philosophy",
      missionTitle: "Our Mission",
      missionDesc: "Transform every company into an exceptional brand, able to stand out, inspire confidence and generate sustainable growth in all markets.",
      visionTitle: "Our Vision",
      visionDesc: "Become the benchmark strategic partner for ambitious companies who want to conquer their markets and leave a memorable imprint in their industry.",
      philosophyTitle: "Our Philosophy",
      philosophyDesc: "We believe that every brand has a unique story to tell. Our role is to reveal this essence, amplify it and transform it into a decisive competitive advantage.",
      multiSectorTitle: "Multi-Sector Expertise",
      allSectorsTitle: "All sectors, all ambitions",
      allSectorsDesc: "Our cross-sector expertise allows us to support companies from all industries. Whatever your activity, we understand your challenges and adapt our strategies to your market.",
      andMore: "+ And many more...",
      industryQuote: "Every industry has its codes. Our strength is to master them to better transcend them.",
      internationalPresence: "International Presence",
      officesTitle: "8 Offices on 3 Continents",
      officesDesc: "Local presence combined with international expertise",
      headquarters: "Headquarters",
      ourClients: "Our Clients",
      whoWeWorkWith: "Who do we work with?",
      clientsDesc: "From startups to large groups, we support all ambitious companies",
      workTogether: "Let's work together",
      workTogetherDesc: "Discover how we can help you achieve your goals",
      yearsLabel: "Years of expertise",
      projectsLabel: "Projects delivered"
    },
    // Offers Page
    offersPage: {
      groupedOffers: "Bundled Offers",
      strategicPacksTitle: "Strategic Packs",
      strategicPacksDesc: "Turnkey solutions to meet your visibility, image or growth objectives",
      flexibility: "Flexibility",
      alaCarteTitle: "À la Carte Services",
      alaCarteDesc: "Do you have a specific need? Each service can be adapted to your budget and objectives.",
      startingPrice: "Starting from €250 per service",
      premiumOffer: "Premium Offer",
      support360Title: "360° Custom Support",
      support360Desc: "For highly ambitious companies, we take charge of your entire communication. From brand strategy to campaign execution, we become your privileged partner.",
      support360Desc2: "A global brand strategy deployed across all channels, with dedicated performance indicators to measure and optimize your results.",
      whatWeHandle: "What we take care of",
      idealFor: "Ideal for:",
      idealForDesc: "Large accounts, fast-growing companies, multi-site organizations",
      faqTitle: "Frequently asked questions",
      faqSubtitle: "Have questions about our offers? We have the answers",
      noAnswer: "Can't find the answer to your question?",
      teamHelp: "Our team is here to help. Contact us directly.",
      ctaTitle: "Ready to transform your brand?",
      ctaSubtitle: "Let's discuss your goals and find the ideal solution together",
      ctaButton1: "Request a free quote",
      ctaButton2: "Discover our services",
      meetUs: "Let's schedule a meeting",
      popular: "Popular"
    },
    // Pack pages
    packs: {
      strategicPack: "Strategic Pack",
      whatsIncluded: "What's included",
      theResult: "The result",
      importantNote: "Important note",
      // Visibility Pack
      visibilityName: "Visibility 360 Pack",
      visibilityTagline: "Want to exist online and attract your first customers?",
      visibilityDesc: "This turnkey pack offers you a complete and coherent digital presence to be visible where your customers are looking for you.",
      visibilityCta: "I want to be visible",
      visibilityResultTitle: "A digital showcase that works for you, 24/7",
      visibilityResultDesc: "With the Visibility 360 Pack, you benefit from a professional and coherent online presence that naturally attracts your potential customers.",
      visibilityFeature1Title: "Professional website",
      visibilityFeature1Desc: "Strategic pages: Home, Services, About, Contact. Modern and responsive design.",
      visibilityFeature2Title: "Basic SEO optimization",
      visibilityFeature2Desc: "To be found on Google by your potential customers.",
      visibilityFeature3Title: "Creation of 3 social networks",
      visibilityFeature3Desc: "Instagram, Facebook, LinkedIn - optimized and ready to use.",
      visibilityFeature4Title: "1 month content planning",
      visibilityFeature4Desc: "Editorial calendar to start your communication smoothly.",
      visibilityBenefit1: "A digital showcase that works for you, 24/7",
      visibilityBenefit2: "Professional presence on social media",
      visibilityBenefit3: "Better visibility on search engines",
      visibilityBenefit4: "Enhanced credibility with your prospects",
      visibilityCtaTitle: "Ready to become visible?",
      continueVisibility: "Continuous visibility",
      // Image Premium Pack
      imageName: "Premium Image Pack",
      imageTagline: "Your brand deserves a strong and memorable identity.",
      imageDesc: "Build a brand that reflects your value and differentiates you from the competition with a coherent and impactful visual identity.",
      imageCta: "I want a unique identity",
      imageResultTitle: "A brand that inspires trust and stands out",
      imageResultDesc: "With the Premium Image Pack, you get a professional and coherent visual identity that positions your company as a reference in your sector.",
      imageFeature1Title: "Complete logo & brand guidelines",
      imageFeature1Desc: "Colors, typography, unique visual universe that represents you.",
      imageFeature2Title: "Essential commercial materials",
      imageFeature2Desc: "Professional flyers, brochure or catalog for your sales.",
      imageFeature3Title: "Social media templates",
      imageFeature3Desc: "Customized visuals ready to use for your publications.",
      imageFeature4Title: "Professional stationery",
      imageFeature4Desc: "Business cards, email signature and personalized letterhead.",
      imageBenefit1: "A brand that inspires trust and stands out",
      imageBenefit2: "Coherent visual identity across all channels",
      imageBenefit3: "Premium perception of your company",
      imageBenefit4: "Increased memorability with your prospects",
      imageCtaTitle: "Ready to create a memorable brand?",
      uniqueCustom: "Unique & custom",
      completeIdentity: "A complete visual identity",
      // Growth Pack
      growthName: "Growth + Pack",
      growthTagline: "Want to generate leads and accelerate your sales?",
      growthDesc: "This pack sets up a high-performance acquisition system to turn your visitors into customers, with automated and measurable processes.",
      growthCta: "I want to grow my revenue",
      growthResultTitle: "A machine for generating qualified leads",
      growthResultDesc: "With the Growth+ Pack, you set up an acquisition system that works for you 24/7, automatically converting your visitors into prospects and then customers.",
      growthFeature1Title: "Strategic audit and recommendations",
      growthFeature1Desc: "Complete analysis of your positioning and personalized action plan.",
      growthFeature2Title: "Complete conversion funnel",
      growthFeature2Desc: "From discovery to purchase: landing pages, sequences, CRO optimization.",
      growthFeature3Title: "Social media test campaign",
      growthFeature3Desc: "Configuration and optimization of your first ad campaigns (budget not included).",
      growthFeature4Title: "Email automation",
      growthFeature4Desc: "Automated sequences to track and convert your prospects.",
      growthBenefit1: "Continuous qualified lead generation",
      growthBenefit2: "Optimized conversion rate at each stage",
      growthBenefit3: "Automated acquisition process",
      growthBenefit4: "Measurable and constantly optimized ROI",
      growthCtaTitle: "Ready to accelerate your growth?",
      growthNote: "The advertising budget (Facebook Ads, Google Ads, LinkedIn Ads) is not included in this pack. We configure and optimize your campaigns, but you manage your budget directly with the platforms. We recommend a minimum test budget to get started.",
      qualifiedLeads: "Qualified leads",
      continuously: "continuously",
      completeAcquisition: "A complete acquisition system"
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('impakt-lang') || 'fr';
    }
    return 'fr';
  });

  useEffect(() => {
    localStorage.setItem('impakt-lang', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
